"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = capitalize;

/**
 * Capitalizes string
 *
 * @param {string} str
 * @returns {string}
 */
function capitalize(str) {
    if (typeof str === "string") {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }
}


//////////////////
// WEBPACK FOOTER
// ./~/kompo-util/lib/capitalize.js
// module id = 18
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11